// Debug Vuex Module
// This module manages debug information and state

const state = {
	debugInfo: {},
	isDebugVisible: false
}

const mutations = {
	SET_DEBUG_INFO(state, { key, value }) {
		state.debugInfo = { ...state.debugInfo, [key]: value }
	},
	CLEAR_DEBUG_INFO(state) {
		state.debugInfo = {}
	},
	TOGGLE_DEBUG(state) {
		state.isDebugVisible = !state.isDebugVisible
	},
	SET_DEBUG_VISIBLE(state, value) {
		state.isDebugVisible = value
	}
}

const actions = {
	addDebugInfo({ commit }, { key, value }) {
		commit('SET_DEBUG_INFO', { key, value })
	},
	clearDebugInfo({ commit }) {
		commit('CLEAR_DEBUG_INFO')
	},
	toggleDebug({ commit }) {
		commit('TOGGLE_DEBUG')
	},
	showDebug({ commit }) {
		commit('SET_DEBUG_VISIBLE', true)
	},
	hideDebug({ commit }) {
		commit('SET_DEBUG_VISIBLE', false)
	},
	updateDebugStructure({ commit, rootGetters }) {
		// Get the page structure from the pageBuilder module
		const structure = rootGetters['pageBuilder/getPageStructure']

		// Add it to debug info
		commit('SET_DEBUG_INFO', { key: 'pageStructure', value: structure })

		// Return the structure so it can be used in the chain
		return Promise.resolve(structure)
	}
}

const getters = {
	getDebugInfo: (state) => state.debugInfo,
	isDebugVisible: (state) => state.isDebugVisible
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
